import {
  ActionType,
  REMOVE_CURRENT_USER,
  SET_CURRENT_USER,
  SET_AUTH,
  REMOVE_AUTH,
} from './CurrentUserAction'
import {UserReduxModel} from '../types'

const initialState = {
  currentUser: null,
  auth: null,
}

const AuthReducer = function (state: UserReduxModel = initialState, action: ActionType) {
  switch (action.type) {
    case SET_CURRENT_USER: {
      return {
        ...state,
        currentUser: {
          ...action.payload,
        },
      }
    }

    case REMOVE_CURRENT_USER: {
      return {
        ...state,
        currentUser: null,
      }
    }

    case SET_AUTH: {
      return {
        ...state,
        auth: action.payload,
      }
    }

    case REMOVE_AUTH: {
      return {
        ...state,
        auth: null,
      }
    }

    default: {
      return {...state}
    }
  }
}

export default AuthReducer
